/**
 * AllAll 图片：flux-kontext-pro
 * 参数与 flux-kontext-max / flux-pro-1.1-ultra / flux-schnell 一致
 */
import { buildBodyWithModel } from './utils'

export function buildBody(params) {
  return buildBodyWithModel('flux-kontext-pro', params)
}
